/* @ngInject */

export default (
  SecuritySplit,
  ContactForValuation,
  TitleDetail,
  OtherMortgage
) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function SecurityDetails(securitySplits, contactsForValuation, titleDetails, otherMortgages) {
    this.securitySplits = securitySplits;
    this.contactsForValuation = contactsForValuation;
    this.titleDetails = titleDetails;
    this.otherMortgages = otherMortgages;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  SecurityDetails.Blank = function () {
    return SecurityDetails.Build({
      securitySplits: [],
      contactsForValuation: [],
      titleDetails: [],
      otherMortgages: []
    });
  };
  SecurityDetails.Build = function (data) {
    return new SecurityDetails(
      _.map(_.compact(data.securitySplits), (securitySplit) =>
        SecuritySplit.Build(securitySplit)
      ),
      _.map(_.compact(data.contactsForValuation), (contactForValuation) =>
        ContactForValuation.Build(contactForValuation)
      ),
      _.map(_.compact(data.titleDetails), (titleDetail) => TitleDetail.Build(titleDetail)),
      _.map(_.compact(data.otherMortgages), (otherMortgage) =>
        OtherMortgage.Build(otherMortgage)
      )
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  SecurityDetails.prototype.deleteDateObject = function () {
    for (let i = 0; i < this.otherMortgages.length; i += 1) {
      delete this.otherMortgages[i].interestOnlyExpiryDateObject;
      delete this.otherMortgages[i].fixedExpiryDateObject;
      if (this.otherMortgages[i].endDate) {
        delete this.otherMortgages[i].endDateObject;
      }
    }
  };

  return SecurityDetails;
};
